import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { dynamoUrlHandler } from 'src/store/modules/user/actions'
import { needToVerifyEmailSelector, isLoggedInSelector } from 'src/store/modules/user/selectors'
import {
  DYNAMO_UTM,
  setDataToLocalStorage,
  DYNAMO_TOKEN,
  getItemFormLocalStorageSelector,
  removeDataFromLocalStorage,
  DYNAMO_UTM_CODE,
} from 'src/utils/localStorage'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'

export default function useDynamoUrl() {
  const pathname = usePathname()
  const query = useSearchParams()
  const dispatch = useAppDispatch()
  const dynamoLinkIdFromUrl = query.get('d10x_link_id')
  const dynamoTokenFromUrl = query.get('d10xlt')
  const dynamoUtmCodeFromUrl = query.get('utm')
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const loggedIn = useAppSelector(isLoggedInSelector)
  const emailNotVerified = useAppSelector(needToVerifyEmailSelector)
  const dynamoUtmFromLs = useAppSelector((state) => getItemFormLocalStorageSelector(state, DYNAMO_UTM, false))
  const dynamoTokenFromLs = useAppSelector((state) => getItemFormLocalStorageSelector(state, DYNAMO_TOKEN, false))
  const dynamoUtmCodeFromLs = useAppSelector((state) => getItemFormLocalStorageSelector(state, DYNAMO_UTM_CODE, false))
  const excludedRoutes = !pathname.includes('confirm-email') && !pathname.includes('login')

  const dynamoUtm = dynamoLinkIdFromUrl || dynamoUtmFromLs
  const dynamoToken = dynamoTokenFromUrl || dynamoTokenFromLs
  const dynamoUtmCode = dynamoUtmCodeFromUrl || dynamoUtmCodeFromLs

  useEffect(() => {
    if (appInitialized && dynamoUtm && dynamoToken && dynamoUtmCode) {
      if (dynamoLinkIdFromUrl) {
        window.history.replaceState({}, document.title, pathname)
      }

      if (loggedIn && !emailNotVerified && excludedRoutes) {
        dispatch(dynamoUrlHandler(dynamoUtm, dynamoToken, dynamoUtmCode))
        dispatch(removeDataFromLocalStorage(DYNAMO_UTM, false))
        dispatch(removeDataFromLocalStorage(DYNAMO_TOKEN, false))
        dispatch(removeDataFromLocalStorage(DYNAMO_UTM_CODE, false))
      } else if (dynamoLinkIdFromUrl && dynamoTokenFromUrl) {
        // only save to localStorage if URL params exist to avoid overwriting with null values
        dispatch(setDataToLocalStorage(DYNAMO_UTM, dynamoLinkIdFromUrl, false))
        dispatch(setDataToLocalStorage(DYNAMO_TOKEN, dynamoTokenFromUrl, false))
        if (dynamoUtmCodeFromUrl) {
          dispatch(setDataToLocalStorage(DYNAMO_UTM_CODE, dynamoUtmCodeFromUrl, false))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appInitialized, loggedIn, emailNotVerified, excludedRoutes])
}
